var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1374_6109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 9,
    width: 13,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2771 9.39465H6V15.8144H18.2771V9.39465Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1374_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1394 9.39465L6 12.1864L12.1398 15.8139L18.2765 12.1864L12.1394 9.39465Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1374_6109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 2,
    width: 7,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1398 2H6V15.8145H12.1398V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1374_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.1865L12.1398 15.8139V2L6 12.1865Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1374_6109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 2,
    width: 7,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2789 2H12.1392V15.8145H18.2789V2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1374_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1392 2V15.8145L18.2763 12.1865L12.1392 2Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1374_6109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 13,
    width: 7,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1398 13.3503H6V22H12.1398V13.3503Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1374_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 13.3503L12.1398 22.0002V16.9778L6 13.3503Z",
    fill: "#010101"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1374_6109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 7,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2814 13.3503H12.1392V22H18.2814V13.3503Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1374_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1392 16.9778V22.0002L18.2814 13.3503L12.1392 16.9778Z",
    fill: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.92b4fe9aa1cebd1012aba1c0f2d6d8af.svg";
export { ForwardRef as ReactComponent };